import {
  getVehiclePartsQueryParamsType,
  getVehiclePartsQueryResponseType,
} from '@/common/queries/selections/vehicleParts/getVehiclePartsQuery.type';
import { fetchApi } from '@/config/axiosSetting';

export const getVehiclePartsQueryFunction = (
  params: getVehiclePartsQueryParamsType,
): Promise<getVehiclePartsQueryResponseType> => {
  return fetchApi.get('/selection_item/vehicle_part/wop_list/', {
    params: {
      id: params.id ?? null,
      side: params.side ?? null,
      vehicle_type: params.vehicle_type ?? null,
    },
  });
};
